import styled from 'styled-components';

const TabTitleStyled = styled.div`
  font-weight: bold;
  color: ${({ active }) => (active ? 'var(--grey800)' : 'white')};
  background-color: ${({ active }) => (active ? 'var(--grey100)' : 'var(--grey700)')};
  font-size: ${({ theme }) => theme.base.textSizes.M};
  border-right: 1px solid var(--grey500);
  flex: 1;
  text-align: center;
  padding: 15px;

  &:hover {
    cursor: pointer;
    background-color: ${({ active }) => (active ? 'var(--grey100)' : 'var(--grey600)')};
  }
`;

export default TabTitleStyled;
